export const actions = {
    GET_USER_PROFILE: 'GET_USER_PROFILE',
    GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
    GET_USER_PROFILE_FAILED: 'GET_USER_PROFILE_FAILED',
    GET_USER_PROFILE_AND_SYNC: 'GET_USER_PROFILE_AND_SYNC',
    SYNCING_USER_PROFILE: 'SYNCING_USER_PROFILE',
    GET_FB_USER_PROFILE: 'GET_FB_USER_PROFILE',
    GET_FB_USER_PROFILE_SUCCESS: 'GET_FB_USER_PROFILE_SUCCESS',
    GET_FB_USER_PROFILE_FAILED: 'GET_FB_USER_PROFILE_FAILED',
    REGISTER_USER_ACCOUNT: 'REGISTER_USER_ACCOUNT',
    REGISTER_USER_ACCOUNT_MFA: 'REGISTER_USER_ACCOUNT_MFA',
    MFA_VERIFY_REGISTER: 'MFA_VERIFY_REGISTER',
    OTP_GENERATE_SUCCESS_REGISTER: 'OTP_GENERATE_SUCCESS_REGISTER',
    REGISTER_USER_ACCOUNT_SUCCESS: 'REGISTER_USER_ACCOUNT_SUCCESS',
    RESET_REGISTER_USER_ACCOUNT_SUCCESS: 'RESET_REGISTER_USER_ACCOUNT_SUCCESS',
    REGISTER_USER_ACCOUNT_FAILED: 'REGISTER_USER_ACCOUNT_FAILED',
    SET_USER_PROFILE: 'SET_USER_PROFILE',
    CLEAR_FORM_ERRORS: 'CLEAR_USER_ACCOUNT_ERRORS',
    SET_NO_CONTACT_DROP_OFF: 'SET_NO_CONTACT_DROP_OFF',
    RESET_USER: 'RESET_USER',
    UPDATE_USER_PROFILE: 'UPDATE_USER_PROFILE',
    UPDATE_USER_PROFILE_SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
    UPDATE_USER_PROFILE_FAILED: 'UPDATE_USER_PROFILE_FAILED',
    RESET_UPDATE_PROFILE: 'RESET_UPDATE_PROFILE',
    SET_AGE_VERIFICATION: 'SET_AGE_VERIFICATION',

    GET_USER_REFERRAL_CODE: 'GET_USER_REFERRAL_CODE',
    GET_USER_REFERRAL_CODE_SUCCESS: 'GET_USER_REFERRAL_CODE_SUCCESS',
    GET_USER_REFERRAL_CODE_FAILURE: 'GET_USER_REFERRAL_CODE_FAILURE',

    USER_AGE_VERIFICATION: 'USER_AGE_VERIFICATION',
    USER_AGE_VERIFICATION_SUCCESS: 'USER_AGE_VERIFICATION_SUCCESS',
    USER_AGE_VERIFICATION_FAILED: 'USER_AGE_VERIFICATION_FAILED',
    SET_AGE_VERIFICATION_FAILED: 'SET_AGE_VERIFICATION_FAILED',
}

export const registerUserAccount = request => ({
    type: actions.REGISTER_USER_ACCOUNT,
    payload: request,
})

export const getUserProfile = request => ({
    type: actions.GET_USER_PROFILE,
    payload: request,
})

export const getUserProfileSuccess = userProfile => ({
    type: actions.GET_USER_PROFILE_SUCCESS,
    payload: userProfile,
})

export const getUserProfileFailed = error => ({
    type: actions.GET_USER_PROFILE_FAILED,
    payload: error,
})

export const getUserProfileAndSync = request => ({
    type: actions.GET_USER_PROFILE_AND_SYNC,
    payload: request,
})

export const syncingProfile = value => ({
    type: actions.SYNCING_USER_PROFILE,
    payload: value,
})

export const registerUserAccountMFA = request => ({
    type: actions.REGISTER_USER_ACCOUNT_MFA,
    payload: request,
})

export const mfaVerifyRegister = request => ({
    type: actions.MFA_VERIFY_REGISTER,
    payload: request,
})

export const otpGenerateSuccess = payload => ({
    type: actions.OTP_GENERATE_SUCCESS_REGISTER,
    payload,
})

export const getFbUserProfile = token => ({
    type: actions.GET_FB_USER_PROFILE,
    payload: token,
})

export const getFbUserProfileSuccess = fbUserProfile => ({
    type: actions.GET_FB_USER_PROFILE_SUCCESS,
    payload: fbUserProfile,
})

export const getFbUserProfileFailed = error => ({
    type: actions.GET_FB_USER_PROFILE_FAILED,
    payload: error,
})

export const registerUserAccountSuccess = userProfile => ({
    type: actions.REGISTER_USER_ACCOUNT_SUCCESS,
    payload: userProfile,
})

export const resetRegisterUserAccountSuccessState = () => ({
    type: actions.RESET_REGISTER_USER_ACCOUNT_SUCCESS,
})

export const registerUserAccountFailed = error => ({
    type: actions.REGISTER_USER_ACCOUNT_FAILED,
    payload: error,
})

export const setUserProfile = profile => ({
    type: actions.SET_USER_PROFILE,
    payload: profile,
})

export const setNoContactDropOff = value => ({
    type: actions.SET_NO_CONTACT_DROP_OFF,
    payload: value,
})

export const clearFormErrors = () => ({
    type: actions.CLEAR_FORM_ERRORS,
})

export const resetUser = () => ({
    type: actions.RESET_USER,
})

export const updateUserProfile = request => ({
    type: actions.UPDATE_USER_PROFILE,
    payload: request,
})

export const ageVerification = request => ({
    type: actions.USER_AGE_VERIFICATION,
    payload: request,
})

export const ageVerificationSuccess = userProfile => ({
    type: actions.USER_AGE_VERIFICATION_SUCCESS,
    payload: userProfile,
})

export const ageVerificationFailed = error => ({
    type: actions.USER_AGE_VERIFICATION_FAILED,
    payload: error,
})

export const updateUserProfileSuccess = userProfile => ({
    type: actions.UPDATE_USER_PROFILE_SUCCESS,
    payload: userProfile,
})

export const updateUserProfileFailed = error => ({
    type: actions.UPDATE_USER_PROFILE_FAILED,
    payload: error,
})

export const updateProfileSetDefaults = () => ({
    type: actions.RESET_UPDATE_PROFILE,
})

export const setAgeVerificationRequired = value => ({
    type: actions.SET_AGE_VERIFICATION,
    payload: value,
})

export const getReferralCode = () => ({
    type: actions.GET_USER_REFERRAL_CODE,
})

export const getReferralCodeSuccess = payload => ({
    type: actions.GET_USER_REFERRAL_CODE_SUCCESS,
    payload,
})

export const getReferralCodeFailure = () => ({
    type: actions.GET_USER_REFERRAL_CODE_FAILURE,
})

export const setAgeVerificationFailed = value => ({
    type: actions.SET_AGE_VERIFICATION_FAILED,
    payload: value,
})
